export * from './change-password.component';
export * from './change-password-request';


// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./~/angular2-template-loader!./src/app/auth/change-password/index.ts